import { MinLength } from 'class-validator';

export class UserAddressDto {
	public id: string;
	public order: number;
	public userId?: string;
	public addressName: string;
	public addressLat: string;
	public addressLng: string;
	public addressCountryId: string;
	public addressStateId: string;
	public addressCityId: string;
}

export class UpdateUserAddressDto {
	@MinLength(3, { message: 'Address is too short' })
	public addressName: string;

	public addressLat: string;

	public addressLng: string;
}
